import { ensureAccessToken, refreshSessionAndGetAccessToken } from "./config/axiosInstance";

/**
 * Axios dışı istekler (SSE `fetch` vb.): önce proaktif token yenileme, 401’de refresh + tek yeniden deneme.
 * `Authorization` ve `Accept-Language` burada set edilir; diğer header’ları `init.headers` ile verin.
 */
export async function fetchWithAuth(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
  const lang = localStorage.getItem("lang") || "tr";

  const buildHeaders = (token: string | null) => {
    const headers = new Headers(init.headers ?? undefined);
    headers.set("Accept-Language", lang);
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    } else {
      headers.delete("Authorization");
    }
    return headers;
  };

  const token = await ensureAccessToken();
  let response = await fetch(input, { ...init, headers: buildHeaders(token) });

  if (response.status === 401) {
    const nextToken = await refreshSessionAndGetAccessToken();
    if (nextToken) {
      response = await fetch(input, { ...init, headers: buildHeaders(nextToken) });
    }
  }

  return response;
}
